import { useEffect, useRef } from 'react';

export const useJobPolling = (job, fetchJobData, intervalMs = 5000) => {
  const pollingInterval = useRef(null);

  useEffect(() => {
    const shouldPoll = job && (job.status === 'PENDING' || job.status === 'STARTED');

    if (shouldPoll && !pollingInterval.current) {
      // Start polling
      pollingInterval.current = setInterval(() => {
        fetchJobData();
      }, intervalMs);
    } else if (!shouldPoll && pollingInterval.current) {
      // Stop polling
      clearInterval(pollingInterval.current);
      pollingInterval.current = null;
    }

    // Cleanup on unmount
    return () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
        pollingInterval.current = null;
      }
    };
  }, [job?.status, fetchJobData, intervalMs]);

  // Cleanup function to stop polling manually
  const stopPolling = () => {
    if (pollingInterval.current) {
      clearInterval(pollingInterval.current);
      pollingInterval.current = null;
    }
  };

  return { stopPolling };
};
